import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import { Button } from "../../components/Form";
import { MdOutlineCloudDownload } from "react-icons/md";
import { toast } from "react-hot-toast";
import { InvoiceTable } from "../../components/Tables";
import { BiPlus } from "react-icons/bi";
import { Link } from "react-router-dom";
import invoiceService from "../../api/invoiceService";

function Invoices() {
  const [invoices, setInvoices] = useState([]);
  const [search, setSearch] = useState("");

  const fetchInvoices = async () => {
    try {
      const res = await invoiceService.getAllInvoices(search);
      // Backend: { success: true, count, total, data: [...] }
      if (res.success) {
        const mappedData = res.data.map((item) => ({
          ...item,
          id: item._id, // Map for table
          // Map 'to' (patient) if populated. Backend: patient: { ... }
          to: item.patient
            ? {
                title: item.patient.fullName,
                email: item.patient.email,
                image: item.patient.image || "/images/user.png",
              }
            : { title: "Unknown", email: "N/A" },
          createdDate: new Date(
            item.paymentDate || item.createdAt
          ).toLocaleDateString(),
          dueDate: new Date(
            item.dueDate || item.createdAt
          ).toLocaleDateString(),
          total: item.totalAmount,
        }));
        setInvoices(mappedData);
      }
    } catch (error) {
      toast.error("Failed to fetch invoices");
    }
  };

  useEffect(() => {
    fetchInvoices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <Layout>
      {/* add button */}
      <Link
        to='/invoices/create'
        className='flex-colo button-fb fixed bottom-8 right-12 z-50 h-16 w-16 animate-bounce rounded-full border border-border bg-[#0095D9] text-white'
      >
        <BiPlus className='text-2xl' />
      </Link>
      {/*  */}
      <h1 className='text-xl font-semibold'>Invoices</h1>
      <div
        data-aos='fade-up'
        data-aos-duration='1000'
        data-aos-delay='100'
        data-aos-offset='200'
        className='my-8 rounded-xl border-[1px] border-border bg-white p-5'
      >
        {/* datas */}

        <div className='grid grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-6'>
          <div className='grid items-center gap-6 md:col-span-5 lg:grid-cols-4'>
            <input
              type='text'
              placeholder='Search "patient name"'
              className='h-14 w-full rounded-md border border-border bg-dry px-4 text-sm text-main'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* export */}
          <Button
            label='Export'
            Icon={MdOutlineCloudDownload}
            onClick={async () => {
              try {
                const blob = await invoiceService.exportInvoicesPdf();
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `Invoices-${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                toast.success("Invoices exported successfully!");
              } catch (error) {
                toast.error("Export failed");
              }
            }}
          />
        </div>
        <div className='mt-8 w-full overflow-x-scroll'>
          <InvoiceTable data={invoices} />
        </div>
      </div>
    </Layout>
  );
}

export default Invoices;
